import { computed, Injectable, Signal } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState, deepComputed } from '@ngrx/signals';

import { Store, useDevtools } from 'signalstory';

import { Content } from '@23degrees/shared-code/domain/content/entities/valueobjects/Content';
import { Layout, LayoutContainer } from '@23degrees/shared-code/domain/content/entities/valueobjects/Layout';
import { withDevtools, withUndoRedo } from '@angular-architects/ngrx-toolkit';

type DataRow = Record<string, unknown>;
export interface ContentSelectorState {
  content: Content;
  data: DataRow[];
  preFilterData: DataRow[];
  preRenderData: DataRow[];
  renderData: DataRow[];
  range: [number, number];
}

const initialState: ContentSelectorState = {
  content: null,
  data: [],
  preFilterData: [],
  preRenderData: [],
  renderData: [],
  range: [0, 0],
};

export const ContentDataStore = signalStore(
  withState(initialState),

  // withUndoRedo({
  //   maxStackSize: 100, // limit of undo/redo steps - `100` by default
  //   collections: [], // entity collections to keep track of - unnamed collection is tracked by default
  //   keys: ['content'], // non-entity based keys to track - `[]` by default
  //   skip: 1, // number of initial state changes to skip - `0` by default
  // }),
  withDevtools('content'),
  withComputed(({ content }) => ({
    slug: computed(() => content()?.slug),
    layout: computed(() => {
      if (!content()) {
        return null;
      }

      const { layout } = content().typeSpecific;
      return layout.layouts[layout.active];
    }),
    atlas: computed(() => content()?.typeSpecific.atlas),
    chart: deepComputed(() => content()?.typeSpecific.chart),
    dash: computed(() => content()?.typeSpecific.dash),
    map: computed(() => content()?.typeSpecific.map),
    style: computed(() => content()?.typeSpecific.style),
  })),
  withMethods((store) => ({
    updateContent(content: Content): void {
      patchState(store, (state) => ({ content: { ...content } }));
    },
    updateData(data: DataRow[]): void {
      patchState(store, (state) => ({ data: [...data] }));
    },
    updatepreFilterData(data: DataRow[]): void {
      patchState(store, (state) => ({ preFilterData: [...data] }));
    },
    updatepreRederData(data: DataRow[]): void {
      patchState(store, (state) => ({ preRenderData: [...data] }));
    },
    updateRenderData(data: DataRow[]): void {
      patchState(store, (state) => ({ renderData: [...data] }));
    },
    updateRange(range: [number, number]): void {
      patchState(store, (state) => ({ range: [range[0], range[1]] as [number, number] }));
    },
    resetContent() {
      patchState(store, (state) => ({ ...state, content: null }));
    },
  })),
);
